/**
 * 지도 OpenLayers 스타일 진입점 — 구현은 @/utils/map/* 에 분리
 */
import { geometryTypeStyles } from '@/utils/map/geometryTypeStyles';
import { geoJsonFeatureStyle } from '@/utils/map/geoJsonFeatureStyles';
import {
  rgbImageFeatureStyle,
  thermalImageFeatureStyle,
  thermalImageSelectedRectStyles
} from '@/utils/map/imageFootprintStyles';
import { pillar, selected_line, dashed_line, color_point } from '@/utils/map/interactionMapStyles';
import {
  solarModule,
  solarModuleByDefectStatus,
  defectModule,
  defectFocusModuleHighlightStyles,
  imageViewStyle
} from '@/utils/map/layerFeatureStyles';
import {
  createMarkerStyle,
  createRecommendMarkerStyle,
  getArrowStyle
} from '@/utils/map/markerArrowStyles';

const DotMapStyle = {
  solarModule,
  solarModuleByDefectStatus,
  defectModule,
  defectFocusModuleHighlightStyles,
  imageViewStyle,
  rgbImageFeatureStyle,
  thermalImageFeatureStyle,
  thermalImageSelectedRectStyles,
  geoJsonFeatureStyle,
  pillar,
  selected_line,
  dashed_line,
  color_point,
  ...geometryTypeStyles,
  createMarkerStyle,
  createRecommendMarkerStyle,
  getArrowStyle
};

export default DotMapStyle;
